__turbopack_context__.v({
  "Acknowledgement": "Footer-module-sass-module__9qRNYa__Acknowledgement",
  "AmosAir": "Footer-module-sass-module__9qRNYa__AmosAir",
  "Brands": "Footer-module-sass-module__9qRNYa__Brands",
  "Cont": "Footer-module-sass-module__9qRNYa__Cont",
  "Footer": "Footer-module-sass-module__9qRNYa__Footer",
  "Logos": "Footer-module-sass-module__9qRNYa__Logos",
  "Menu": "Footer-module-sass-module__9qRNYa__Menu",
  "MenuList": "Footer-module-sass-module__9qRNYa__MenuList",
  "OfficeLinks": "Footer-module-sass-module__9qRNYa__OfficeLinks",
  "Offices": "Footer-module-sass-module__9qRNYa__Offices",
});
